import { http } from '@pendo/http';

export function fetchServiceAccounts () {
    return http.get('/api/s/_SID_/serviceaccount');
}

export function createServiceAccount ({ serviceAccount }) {
    return http.post('/api/s/_SID_/serviceaccount', serviceAccount);
}

export function deleteServiceAccount ({ id }) {
    return http.delete(`/api/s/_SID_/serviceaccount/${id}`);
}

export function rotateServiceAccountSecret ({ id }) {
    return http.post(`/api/s/_SID_/serviceaccount/${id}/rotate`);
}
